module.exports = __webpack_public_path__ + "static/media/r-background.85740021.png";